module.exports = __webpack_public_path__ + "static/img/home.b85c6ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/home.png
// module id = tBq7
// module chunks = 108